import querystring from 'querystring';
import { selector } from 'recoil';
import axios from '../../common/axiosInterceptor';
import { replaceAgentForm } from '../atoms/replaceAgentForm';
import { agentUserId } from '../atoms/agentUserId';
import { user } from '../atoms/user';
export const replaceAgent = selector({
  key: 'replaceAgent',
  get: async ({ get }) => {
    try {
      // subscribe to editProfileForm
      const formData = get(replaceAgentForm);
      const currentUser = get(agentUserId);
      const storageUser = get(user);
      if (formData.fname.length >= 1) {
        const url =
          `${process.env.VITE_APP_PHP_DOMAIN}/rest/functions.php?` +
          querystring.stringify({
            call: 'webUpdateKixieManagerReplaceUser',
            fname: formData.fname,
            lname: formData.lname,
            email: formData.email,
            calleridNumber: formData.calleridNumber,
            callerid: formData.callerid,
            smsNumber: formData.smsNumber,
            businessid: storageUser.businessid,
            userid: currentUser.id,
            apiKey: storageUser.apikey,
          });
        const result = await axios.post(url, null, { withCredentials: true });
        return result;
      } else {
        const result = {};
        return result;
      }
    } catch (error) {
      throw error;
    }
  },
});
